import { render, staticRenderFns } from "./freeShippingSlider.vue?vue&type=template&id=0484b3da&scoped=true"
import script from "./freeShippingSlider.vue?vue&type=script&lang=js"
export * from "./freeShippingSlider.vue?vue&type=script&lang=js"
import style1 from "./freeShippingSlider.vue?vue&type=style&index=1&id=0484b3da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484b3da",
  null
  
)

export default component.exports